/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'sarsaparilla';

const propTypes = {
    onStart: PropTypes.func,
};

const defaultProps = {};

export default class QuestionnaireStart extends React.Component {
    constructor(props) {
        super(props);
        this.onStart = this.onStart.bind(this);
    }

    onStart(e) {
        e.preventDefault();
        this.props.onStart();
    }

    render() {
        return (
            <div className="rec-questionnaire-intro">
                <h1 className="h3">Which Permit Do I Need?</h1>
                <p className={'subheader'}>For Boundary Waters Canoe Area Wilderness</p>
                <p className={'content'}>
                    Answer the questions on the following pages to find the best permit
                    you need to reserve for your trip.
                </p>
                <Button className="rec-button-primary" onClick={this.onStart}>
                    Let&apos;s Begin
                </Button>
            </div>
        );
    }
}

QuestionnaireStart.displayName = 'QuestionnaireStart';
QuestionnaireStart.propTypes = propTypes;
QuestionnaireStart.defaultProps = defaultProps;
